class Radios extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.current_value = this.querySelector(".radios--option-current")),
      (this.inputs = this.querySelectorAll("input")),
      (this.is_swatches = "true" === this.getAttribute("data-is-swatches")),
      this.preventFormSubmitOnEnter(),
      this.is_swatches &&
        (theme.utils.setSwatchColors(this.inputs), this.current_value) &&
        this.updateLabelOnChange(),
      (this.is_product_page = null !== this.closest(".product-page--root"));

    // ============ ADDED CODE ============

    // Add Select First Function - select the first variant in collection-quick-add form or product page
    this.drawerContainer = this.closest(
      '.drawer--container[data-view="product-form"]'
    );
    this.selectFirstVariant();
  }
  disconnectedCallback() {
    this.inputs.off("keydown.Radios change.Radios");
  }
  preventFormSubmitOnEnter() {
    this.inputs.on("keydown.Radios", (t) => {
      "Enter" === t.key && t.preventDefault();
    });
  }
  updateLabelOnChange() {
    this.inputs.on("change.Radios", (t) => {
      this.current_value.textContent = t.target.value;
    });
  }

  selectFirstVariant() {
    const variantChecked = this.querySelector(
      ".radios--input.isVariantChecked"
    );

    this.is_product_page &&
    typeof variantChecked != "undefined" &&
    variantChecked != null
      ? variantChecked.click()
      : window.on("theme:drawer:right:opening", () => {
          variantChecked.checked = true;
        });
  }
}
customElements.define("radios-root", Radios);
